<template>
  <div class="sign-meeting-form form-required">
    <label v-if="showDeclaration" class="sign-meeting-declaration">
      <input type="checkbox" v-model="value" :disabled="disableCheckbox"/>
      <span>I confirm that these notes are a true and accurate account of this meeting, and acknowledge that they will be retained as part of the learning record.</span>
    </label>
    <template v-if="showSigningButton">
      <k-status-pill v-if="!showDeclaration" type="success" statusValue="Meeting Signed">
        <template #label>
          Meeting Completed <i class="fas fa-check" aria-hidden="true"></i>
        </template>
      </k-status-pill>
      <button v-else
        class="btn btn-success"
        type="button"
        :disabled="disableButton"
        @click.prevent="$emit('button-click')"
      >
        Sign Meeting Form
      </button>
    </template>
  </div>
</template>

<style scoped>
.sign-meeting-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sign-meeting-declaration > span {
  margin-left: 5px;
}
</style>

<script>
import KStatusPill from '@base-components/k-status-pill.vue';

export default {
  emits: ['update:modelValue', 'button-click'],
  components: {
    KStatusPill,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    showDeclaration: {
      type: Boolean,
      default: true,
    },
    showSigningButton: {
      type: Boolean,
      default: false,
    },
    disableCheckbox: {
      type: Boolean,
      default: false,
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      value: this.modelValue,
    };
  },

  watch: {
    value(val) {
      this.$emit('update:modelValue', val);
    },
    modelValue(val) {
      this.value = val;
    },
  },
};
</script>
